import { useState } from 'react';
import styles from './Profile.module.css';
import DefaultPhoto from './../../../assets/images/Photo.png';
import IconAndName from '../../../components/IconAndName/IconAndName';
import ResultAndCount from '../../../components/ResultAndCount/ResultAndCount';
import ExpandableCard from '../../../components/ExpandableCard/ExpandableCard';
import HeadingAndData from '../../../components/HeadingAndData/HeadingAndData';
import RadioComponent from '../../../components/RadioComponent/RadioComponent';
import HeadingAndDropDown from '../../../components/HeadingAndDropDown/HeadingAndDropDown';
import CalendarInput from '../../../components/CalendarInput/CalendarInput';
import IconAndHeading from '../../../components/IconAndHeading/IconAndHeading';
import { PiStudentBold } from 'react-icons/pi';
import {
  AiOutlineSafetyCertificate,
  AiOutlineMan,
  AiOutlineWoman,
} from 'react-icons/ai';
import { IoPersonAddOutline } from 'react-icons/io5';
import SaveAndCancel from '../../../components/SaveAndCancel/SaveAndCancel';

const Profile = () => {
  const studentProfileData = [
    { heading: 'ID', data: '356467' },
    { heading: 'Age', data: '2 Yrs' },
    { heading: 'Date of Birth', data: '27/08/2025' },
    { heading: 'Admission No', data: '12358672' },
  ];

  const [gender, setGender] = useState('Male');

  return (
    <div className={styles.Profile}>
      {/* Student Top Section */}
      <section className={styles.studentProfileDetails}>
        <header className={styles.header}>
          <p className={styles.title}>Student Details</p>
          <IconAndName title="Send Parent Invite" />
        </header>
        <main className={styles.mainContent}>
          <div className={styles.DetailsContainer}>
            <img
              src={DefaultPhoto}
              alt="Student"
              className={styles.studentPhoto}
            />
            <div className={styles.StudentData}>
              <p className={styles.studentName}>Steve John</p>
              <div className={styles.studentInfo}>
                {studentProfileData.map((item, index) => (
                  <div className={styles.infoItem} key={index}>
                    <p className={styles.infoTitle}>{item.heading}</p>
                    <p className={styles.infoData}>{item.data}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.resultandcount}>
            <ResultAndCount
              label="Attendance %"
              count={10}
              bgColor="rgba(from var(--Success_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Days Present"
              count={2}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Days Absent"
              count={1}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Black_Color"
            />

            <ResultAndCount
              label="Leaves Count"
              count={3}
              bgColor="rgba(from var(--Error_Color) r g b / 0.2)"
              textColor="Black_Color"
            />
          </div>
        </main>
      </section>

      {/* Student Details */}
      <ExpandableCard
        bodyColor="var(--White_Color)"
        headerColor="var(--Utility_Color1)"
        header={
          <IconAndHeading
            icon={<PiStudentBold color="var(--White_Color)" size={20} />}
            heading="Student Details"
            headingColor="var(--Primary_Color)"
            iconBackgroundColor={'rgba(from var(--Info_Color) r g b / 0.5)'}
          />
        }
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData
            label="Student First Name"
            name="firstName"
            placeholder="Enter First Name"
            required
          />
          <HeadingAndData
            label="Student Last Name"
            name="lastName"
            placeholder="Enter Last Name"
            required
          />
          <div className={styles.radioGroup}>
            <span className={styles.Label}>Gender *</span>
            <div className={styles.radioOptions}>
              <RadioComponent
                name="gender"
                value="Male"
                label="Male"
                checked={gender === 'Male'}
                onChange={(e) => setGender(e.target.value)}
              />
              <RadioComponent
                name="gender"
                value="Female"
                label="Female"
                checked={gender === 'Female'}
                onChange={(e) => setGender(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={styles.three1frItemsFormRow}>
          <HeadingAndDropDown
            label="Room"
            options={[{ label: '2A', value: '2A' }]}
            required
          />
          <HeadingAndDropDown
            label="Group"
            options={[{ label: 'Eee', value: 'Eee' }]}
          />
          <HeadingAndDropDown
            label="Program"
            options={[{ label: "Children's day", value: 'Children' }]}
            required
          />
        </div>

        <div className={styles.three1frItemsFormRow}>
          <CalendarInput
            label="Date Of Birth"
            fieldLabel="Date Of Birth"
            required
          />
          <HeadingAndDropDown
            label="Status"
            options={[{ label: 'Active', value: 'Active' }]}
            required
          />
          <CalendarInput
            label="Admission Date"
            fieldLabel="Admission Date"
            required
          />
        </div>

        <div className={styles.three1frItemsFormRow}>
          <CalendarInput
            label="Registration Date"
            fieldLabel="Registration Date"
            required
          />
          <HeadingAndData
            label="Address"
            name="address"
            placeholder="Enter address"
            required
          />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>

      {/* Health and Emergency Info */}
      <ExpandableCard
        bodyColor="var(--White_Color)"
        headerColor="var(--Utility_Color1)"
        header={
          <IconAndHeading
            iconBackgroundColor={'rgba(from var(--Info_Color) r g b / 0.5)'}
            icon={<AiOutlineSafetyCertificate size={18} />}
            heading="Health And Emergency Information"
            headingColor="var(--Primary_Color)"
          />
        }
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Blood Group" name="bloodGroup" value="B+" />
          <HeadingAndData label="Allergies" name="allergies" value="NO" />
          <HeadingAndData label="Medication" name="medication" value="NO" />
        </div>
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Enter emergency Contact" value="3456789076" />
          <HeadingAndData label="Enter emergency name" value="1234567890" />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>

      {/* Father Details */}
      <ExpandableCard
        bodyColor="var(--White_Color)"
        headerColor="var(--Utility_Color1)"
        header={
          <IconAndHeading
            icon={<AiOutlineMan size={18} />}
            heading="Father Details"
            headingColor="var(--Primary_Color)"
            iconBackgroundColor={'rgba(from var(--Info_Color) r g b / 0.5)'}
          />
        }
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Father Name" value="john" required />
          <HeadingAndData
            label="Father Mobile Number"
            value="2324561234"
            required
          />
          <HeadingAndData label="Father Email ID" value="nhshsb@gmail.com" />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>

      {/* Mother Details */}
      <ExpandableCard
        headerColor="var(--Utility_Color1)"
        bodyColor="var(--White_Color)"
        header={
          <IconAndHeading
            icon={<AiOutlineWoman size={18} />}
            heading="Mother Details"
            headingColor="var(--Primary_Color)"
            iconBackgroundColor={'rgba(from var(--Info_Color) r g b / 0.5)'}
          />
        }
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Mother Name" value="HYY" required />
          <HeadingAndData
            label="Mother Mobile Number"
            value="6457890834"
            required
          />
          <HeadingAndData label="Mother Email ID" value="gfrgsl@gmail.com" />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>

      {/* Additional Authorized Pickup */}
      <ExpandableCard
        headerColor="var(--Utility_Color1)"
        header={
          <IconAndHeading
            icon={<IoPersonAddOutline size={18} />}
            heading="Additional authorized pickup"
            headingColor="var(--Primary_Color)"
            iconBackgroundColor={'rgba(from var(--Info_Color) r g b / 0.5)'}
          />
        }
        bodyColor="var(--White_Color)"
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Name" value="John" required />
          <HeadingAndData label="Mobile Number" value="2345678901" required />
          <HeadingAndData label="Email ID" value="errhqq@gmail.com" />
        </div>
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData label="Relation Name" value="Brother" required />
          <HeadingAndData label="Address" value="erragadda" required />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>
    </div>
  );
};

export default Profile;
